/**
 * defines the common methods for the barcode
 */
export class BarcodeBase {
}
